import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell, X } from "lucide-react";
import { getCurrentSubscription, needsIOSInstall, pushSupported } from "../lib/push";

const DISMISS_KEY = "mc_push_nudge_dismissed_at";
const DISMISS_DAYS = 7;

export const PushNudge = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const dismissed = Number(localStorage.getItem(DISMISS_KEY) || 0);
    if (Date.now() - dismissed < DISMISS_DAYS * 864e5) return;
    if (needsIOSInstall()) { setShow(true); return; }
    if (!pushSupported() || Notification.permission === "denied") return;
    getCurrentSubscription().then((sub) => setShow(!sub)).catch(() => undefined);
  }, []);

  if (!show) return null;
  const dismiss = () => { localStorage.setItem(DISMISS_KEY, String(Date.now())); setShow(false); };

  return (
    <div data-testid="push-nudge" className="flex items-center gap-3 bg-[#1A1D26] border border-[#FF6B00]/40 rounded-xl px-4 py-3 mb-4">
      <Bell className="w-5 h-5 text-[#FF6B00] shrink-0" />
      <p className="text-xs text-gray-200 flex-1">
        Ative as notificações para receber avisos do mentor, lembretes de aulas e novas fases liberadas.
      </p>
      <Link data-testid="push-nudge-activate-link" to="/perfil" onClick={dismiss}
        className="text-[11px] font-extrabold uppercase text-[#FF6B00] hover:text-[#FF8533] whitespace-nowrap">
        Ativar
      </Link>
      <button data-testid="push-nudge-dismiss-btn" onClick={dismiss} className="text-gray-500 hover:text-white">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
